// Services
import JsonService from './json-helper.service';

export default {
  async formatItemData(rawData, columns) {
    return JsonService.filterPropertiesByArray(rawData, columns);
  }
};
